import type {
  IAvailableDoctorTimeProps,
  IAvailableVisit,
  IAvailableVisitType,
} from "./types";

import { useConvertDate } from "@/utils";

function getAvailableVisitTime(
  visitTypeData: IAvailableVisit[],
  type: IAvailableVisitType,
  canShow: boolean,
) {
  if (!canShow) return;

  const foundItem = visitTypeData.find((item) => item.type.key === type);

  if (
    foundItem &&
    foundItem.available === true &&
    foundItem.first_time_available !== null
  ) {
    return foundItem;
  }
}

export default function useAvailableTimes(
  showVisitType: IAvailableDoctorTimeProps["showVisitType"],
  visitTypeData: IAvailableDoctorTimeProps["visitType"],
) {
  const { humanizeFullDate } = useConvertDate();

  // `all` or `online_visit`
  const canShowOnlineVisitTime = showVisitType !== "in_person_visit";
  // `all` or `in_person_visit`
  const canShowInPersonVisitTime = showVisitType !== "online_visit";

  const onlineVisitData = getAvailableVisitTime(
    visitTypeData,
    "online_visit",
    canShowOnlineVisitTime,
  );
  const inPersonVisitData = getAvailableVisitTime(
    visitTypeData,
    "in_person_visit",
    canShowInPersonVisitTime,
  );

  const areTimesTheSame =
    onlineVisitData &&
    inPersonVisitData &&
    onlineVisitData.first_time_available?.from ===
      inPersonVisitData.first_time_available?.from;

  const onlineVisitTime = onlineVisitData?.first_time_available?.from
    ? humanizeFullDate(onlineVisitData.first_time_available.from)
    : undefined;

  const inPersonVisitTime = inPersonVisitData?.first_time_available?.from
    ? humanizeFullDate(inPersonVisitData.first_time_available.from)
    : undefined;

  const noAvailableTime = !onlineVisitData && !inPersonVisitData;

  return {
    onlineVisitData,
    inPersonVisitData,
    areTimesTheSame,
    onlineVisitTime,
    inPersonVisitTime,
    noAvailableTime,
    canShowOnlineVisitTime,
    canShowInPersonVisitTime,
  };
}
